module.exports = "/_next/static/images/step_1-ff2889fd5fc9876bac0843f562efd9f1.png";